import type { InsufficientCredits } from "shared/api/creditDenial";
import { CABINET_BILLING_URL } from "shared/utils/url.utils";

/**
 * The back office's own address wins: it is `config('credits.buy_url')`, set
 * per environment. Anything that is not a plain web address is ignored.
 */
export const buyCreditsUrl = (denial: InsufficientCredits): string => {
  const url = denial.buy_url;

  return typeof url === "string" && /^https?:\/\//i.test(url) ? url : CABINET_BILLING_URL;
};
